import createDebug from 'debug'

export const debug = createDebug('sanity:document-store')
